/* Partner report 2026-09-09: re-adding the ChatGPT connector while the
   browser still carried a live Dathent session left no way to sign out and
   connect a different account from the consent page. dathent-mcp-worker's
   renderConsentPage now links "Not you? Use a different account" to
   `${appOrigin}/logout?next=<the pending authorize URL, encoded>` — this is
   the pure decision behind that /logout route (screens/Logout.jsx): where to
   send the browser once signed out.

   Pulled out as a standalone function for the same reason safeNext.js is:
   testable without a DOM. Reuses safeNext's allowlist (this environment's
   API origin, /oauth-mcp/ paths only) rather than re-deriving it — an
   unvalidated `next` could otherwise turn /logout into an open redirect. */
import { safeNext } from './safeNext.js';

// Returns the app-relative path to navigate to after signing out: `/login`
// carrying `next` through (re-validated, so /logout itself can never become
// an open redirect) when it passes the allowlist, or bare `/login` otherwise.
export function logoutRedirectTarget(next, baseURL) {
  const safe = safeNext(next, baseURL);
  return safe ? `/login?next=${encodeURIComponent(safe)}` : '/login';
}
